// extracted by mini-css-extract-plugin
export default {"buttonContentContainer":"ConfirmOrder_buttonContentContainer__1KUQ3","flexContainer":"ConfirmOrder_flexContainer__sEnFE"};